import React from 'react';

export const EmptyAiDocument = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="68"
    height="69"
    viewBox="0 0 68 69"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.47395 29.2363H27.0401V33.7496H5.22616V61.4195L10.0102 57.2278L10.0459 57.1977C10.7237 56.628 11.5807 56.3157 12.4661 56.3157H36.8188V46.4715H41.332V57.0679C41.332 58.0654 40.9358 59.0221 40.2305 59.7274C39.5251 60.4327 38.5685 60.829 37.571 60.829H12.7482L6.92991 65.9289L6.89418 65.959C6.2204 66.5299 5.36649 66.8443 4.48336 66.8466C3.93149 66.8453 3.3866 66.7233 2.8868 66.4893C2.23571 66.1908 1.68441 65.7111 1.29888 65.1074C0.913354 64.5038 0.709919 63.8018 0.712923 63.0856V32.9974C0.712923 31.9999 1.10917 31.0432 1.8145 30.3379C2.51983 29.6326 3.47647 29.2363 4.47395 29.2363Z"
      fill="#3655C5"
    />
    <path
      d="M33.0577 37.0092V4.91506C33.0577 4.38307 33.2691 3.87286 33.6452 3.49669C34.0214 3.12051 34.5316 2.90918 35.0636 2.90918H47.4439C48.5078 2.90941 49.5281 3.33222 50.2802 4.08463L59.9646 13.769C60.7171 14.5212 61.1399 15.5414 61.1401 16.6053V37.0092C61.1401 37.5412 60.9288 38.0514 60.5526 38.4276C60.1764 38.8037 59.6662 39.0151 59.1342 39.0151H35.0636C34.5316 39.0151 34.0214 38.8037 33.6452 38.4276C33.2691 38.0514 33.0577 37.5412 33.0577 37.0092Z"
      stroke="#3655C5"
      stroke-width="4.41294"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M67.2871 60.3197C64.6394 59.0351 62.501 56.8968 61.2164 54.249C59.9318 56.8968 57.7934 59.0351 55.1457 60.3197C57.7934 61.6044 59.9318 63.7427 61.2164 66.3904C62.501 63.7427 64.6394 61.6044 67.2871 60.3197Z"
      fill="url(#paint0_linear_1960_30325)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M54.1743 49.8779C53.4036 51.4666 52.1206 52.7496 50.5319 53.5204C52.1206 54.2911 53.4036 55.5741 54.1743 57.1628C54.9451 55.5741 56.2281 54.2911 57.8168 53.5204C56.2281 52.7496 54.9451 51.4666 54.1743 49.8779Z"
      fill="url(#paint1_linear_1960_30325)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M52.3531 62.0205C51.7108 63.3444 50.6416 64.4135 49.3177 65.0559C50.6416 65.6982 51.7108 66.7674 52.3531 68.0912C52.9954 66.7674 54.0646 65.6982 55.3885 65.0559C54.0646 64.4135 52.9954 63.3444 52.3531 62.0205Z"
      fill="url(#paint2_linear_1960_30325)"
    />
    <path
      d="M47.0989 2.90918V14.9445C47.0989 15.4765 47.3103 15.9867 47.6864 16.3628C48.0626 16.739 48.5728 16.9504 49.1048 16.9504H61.1401"
      stroke="#3655C5"
      stroke-width="4.41294"
      stroke-linejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1960_30325"
        x1="55.3935"
        y1="54.249"
        x2="66.5742"
        y2="54.249"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F54BEA" />
        <stop offset="1" stop-color="#F9975E" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1960_30325"
        x1="50.6806"
        y1="49.8779"
        x2="57.3891"
        y2="49.8779"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F54BEA" />
        <stop offset="1" stop-color="#F9975E" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1960_30325"
        x1="49.4416"
        y1="62.0205"
        x2="55.032"
        y2="62.0205"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F54BEA" />
        <stop offset="1" stop-color="#F9975E" />
      </linearGradient>
    </defs>
  </svg>
);
